export const KEY_PREFIX = 'postgrest';
export const POSTGREST_FILTER_KEY_PREFIX = 'postgrest-filter';
export const KEY_SEPARATOR = '$';
export const INFINITE_PREFIX = '$inf$';
export const INFINITE_KEY_PREFIX = 'page';
